var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.5,
    fill: "white",
    stroke: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.875C11.6192 10.875 10.875 11.6192 10.875 12.5C10.875 13.3808 11.6192 14.125 12.5 14.125C13.3808 14.125 14.125 13.3808 14.125 12.5C14.125 11.6192 13.3808 10.875 12.5 10.875Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8334 8.70837H15.4326L13.9663 7.24208C13.9161 7.19168 13.8564 7.15172 13.7907 7.12448C13.725 7.09724 13.6545 7.08327 13.5834 7.08337H11.4167C11.3456 7.08327 11.2751 7.09724 11.2094 7.12448C11.1437 7.15172 11.084 7.19168 11.0337 7.24208L9.56746 8.70837H8.16671C7.56925 8.70837 7.08337 9.19425 7.08337 9.79171V15.75C7.08337 16.3475 7.56925 16.8334 8.16671 16.8334H16.8334C17.4308 16.8334 17.9167 16.3475 17.9167 15.75V9.79171C17.9167 9.19425 17.4308 8.70837 16.8334 8.70837ZM12.5 15.2084C11.0321 15.2084 9.79171 13.968 9.79171 12.5C9.79171 11.0321 11.0321 9.79171 12.5 9.79171C13.968 9.79171 15.2084 11.0321 15.2084 12.5C15.2084 13.968 13.968 15.2084 12.5 15.2084Z",
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraGrayIcon);
export default __webpack_public_path__ + "static/media/CameraGrayIcon.41346366.svg";
export { ForwardRef as ReactComponent };